<template>
    <div class="form-container" :class="{'shrink-container': paymentInfoStep} ">
        <form  id="subscription-form" @submit.stop.prevent v-if="!paymentInfoStep">
            <div class="checkout-steps">             
                <div class="step payment-info">
                    <h4>{{$t('subscription.checkout-step-1')}}</h4>
                    <div class="payment-frequency">
                        <div class="monthly" :class="{active: paymentFrequency == 'month'}" @click="paymentFrequency = 'month'">
                            <p class="payment-header">{{$t('subscription.pay-monthly')}}</p>
                            <p class="payment-pricing">
                                <span>{{monthlyPrice.currency}}</span>
                                <span>{{parseInt(monthlyPrice.price).toLocaleString().replace(/\./g, ' ')}}</span>
                                <span>{{$t('subscription.month-frequency')}}</span>
                            </p>
                            <p class="binding">{{$t('subscription.min-subscription-period')}}</p>
                            <p class="total-year">
                                {{$t('subscription.total-price-1-year')}} 
                                <span>{{monthlyPrice.currency}}</span>
                                <span>{{annualPriceIfMonthly}}</span>
                            <!-- <span>{{$t('subscription.year-frequency')}}</span> -->
                            </p>
                        </div>
                        <div class="annually" :class="{active: paymentFrequency == 'year'}" @click="paymentFrequency = 'year'">
                            <p class="payment-header">{{$t('subscription.pay-annually')}}</p>
                            <p class="payment-pricing">
                                <span>{{annualPrice.currency}}</span>
                                <span>{{parseInt(annualPrice.price).toLocaleString().replace(/\./g, ' ')}}</span>
                                <span>{{$t('subscription.year-frequency')}}</span>
                            </p>
                            <p class="binding">{{$t('subscription.min-subscription-period')}}</p>
                            <p class="total-year">
                                {{$t('subscription.total-price-1-year')}}
                                <span>{{annualPrice.currency}}</span>
                                <span>{{parseInt(annualPrice.price).toLocaleString().replace(/\./g, ' ')}}</span>
                                <!-- <span>/{{annualPrice.interval_type}}</span> -->
                            </p>
                            <p class="saving-year">
                                {{$t('subscription.savings-count')}}
                                <span>{{annualPrice.currency}}</span>
                                <span>{{annualPriceIfAnnual}}</span>
                                <span>{{$t('subscription.year-frequency')}}</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="step master-data">
                    <h4>{{$t('subscription.checkout-step-2')}}</h4>
                    <custom-input :inputType="'text'" v-model="billingInfo.name" :name="'name'" :label="$t('subscription.form.company')" :placeholder="$t('subscription.form.company-ph')" :isDisabled="true" :isRequired="false"/>
                    <custom-input :inputType="'text'" v-model="billingInfo.vatNumber" :name="'CVR'" :label="$t('subscription.form.vat')" :placeholder="$t('subscription.form.vat-ph')" :focusInputField="true" :isRequired="false"/>
                    <custom-input :inputType="'text'" v-model="billingInfo.legalAddress.address" :name="'address'" :label="$t('subscription.form.address')" :placeholder="$t('subscription.form.address-ph')" :isRequired="false" :invalidInput="invalidInputs.includes('address')"/>
                    <div class="city-info">
                        <custom-input :inputType="'text'" v-model="billingInfo.legalAddress.postalCode" :name="'zipCode'" :label="$t('subscription.form.zip')" :placeholder="$t('subscription.form.zip-ph')" :isRequired="false" :invalidInput="invalidInputs.includes('zipCode')"/>
                        <custom-input :inputType="'text'" v-model="billingInfo.legalAddress.city" :name="'city'" :label="$t('subscription.form.city')" :placeholder="$t('subscription.form.city-ph')" :isRequired="false" :invalidInput="invalidInputs.includes('city')"/>
                    </div>
                    <!-- <custom-input :inputType="'text'" v-model="billingInfo.contact" :name="'contact'" :label="'Contact person'" :placeholder="'e.g Marc Aas Nilsson'"/> -->
                    <country-search 
                        :selectedValue="billingInfo.legalAddress.country"
                        :invalidInput="invalidInputs.includes('country')"
                        :name="'country'"
                        :startingValue="billingInfo.legalAddress.country || ''"
                        @on-element-selected="country => billingInfo.legalAddress.country = country"
                        @on-element-reset="billingInfo.legalAddress.country = null"
                    />
                </div>

                <div class="step recipient-data">
                     <h4>{{$t('subscription.checkout-step-3')}}</h4>
                    <custom-input :inputType="'text'" v-model="billingInfo.contact.name" :name="'contact_name'" :label="$t('subscription.form.name')" :placeholder="$t('subscription.form.name-ph')" :isRequired="false" :invalidInput="invalidInputs.includes('contact-name')"/>        
                    <custom-input :inputType="'text'" v-model="billingInfo.contact.email" :name="'email'" :label="$t('subscription.form.email')" :placeholder="$t('subscription.form.email-ph')" :isRequired="false" :invalidInput="invalidInputs.includes('email')" />
                    <!-- <custom-input :inputType="'text'" v-model="billingInfo.contact_phone" :name="'contact_phone'" :label="$t('subscription.form.phone')" :placeholder="$t('subscription.form.phone-ph')" :isRequired="false" :invalidInput="invalidInputs.includes('contact_phone')"/>    -->

                    <checkbox
                        class="custom-billing"
                        :label="$t('subscription.billing-same-as-legal-label')"
                        :name="'TermsConditions'"
                        :lightLabel="true"
                        v-model="showBillingAddress"
                    />  

                    <div v-if="billingInfo.billingSameAsLegal == false">
                        <custom-input :inputType="'text'" v-model="billingInfo.billingAddress.address" :name="'billing-address'" :label="$t('subscription.form.billing-address')" :placeholder="$t('subscription.form.billing-address-ph')" :isRequired="false" :invalidInput="invalidInputs.includes('billing-address')" :focusInputField="true"/>
                        <div class="city-info">
                            <custom-input :inputType="'text'" v-model="billingInfo.billingAddress.postalCode" :name="'billing-zipCode'" :label="$t('subscription.form.billing-zip')" :placeholder="$t('subscription.form.billing-zip-ph')" :isRequired="false" :invalidInput="invalidInputs.includes('billing-zipCode')"/>
                            <custom-input :inputType="'text'" v-model="billingInfo.billingAddress.city" :name="'billing-city'" :label="$t('subscription.form.billing-city')" :placeholder="$t('subscription.form.billing-city-ph')" :isRequired="false" :invalidInput="invalidInputs.includes('billing-city')"/>
                        </div>
                        <country-search 
                            :selectedValue="billingInfo.billingAddress.country"
                            :invalidInput="invalidInputs.includes('country')"
                            :name="'billing-country'"
                            :startingValue="billingInfo.billingAddress.country || ''"
                            @on-element-selected="country => billingInfo.billingAddress.country = country"
                            @on-element-reset="billingInfo.billingAddress.country = null"
                        />
                    </div>
                
                    <div class="actions">
                        <div class="terms">
                            <checkbox
                                :label="termsNConditions"
                                :name="'TermsConditions'"
                                :lightLabel="true"
                                v-model="tersmChecked"
                            />
                        </div>
                        <button type="submit" class="btn btn-primary" :disabled="!valid" @click="gatherInfo">{{$t('subscription.to-payment')}}</button>
                    </div>     
                </div>
                    <!-- <custom-input :inputType="'text'" v-model="billingInfo.country" :name="'country'" :label="'Country'" :placeholder="'e.g Denmark'" :isRequired="false" :invalidInput="invalidInputs.includes('country')"/>         -->
            </div>
            <div class="order-review">
                <div>
                    <div class="chosen-plan">
                        <h4>{{$t('subscription.order-summary')}}</h4>
                        <subscription-plan 
                            class="plan" 
                            :plan="plan" 
                            :paymentFrequency="paymentFrequency" 
                            :currentCurrency="currentCurrency" 
                            :showPlansDropdown="true"
                            :plans="plans"
                            @changed-plan="otherPlan => $emit('changed-plan', otherPlan)"
                        />
                    </div>
                        <p class="vat-notice"> {{$t('subscription.VAT-notice')}}</p>
                </div>
            </div>
        </form>
        <payment-step 
            v-else 
            :billingInfo="billingInfo" 
            :plan="plan" 
            :annualPriceIfMonthly="annualPriceIfMonthly"
            :paymentFrequency="paymentFrequency" 
            @set-card-id="cardId => billingInfo.cardId = cardId"
        />
    </div>
</template>

<script>
import SubscriptionPlan from "@/components/SubscriptionPlan";
import CustomInput from "@/components/CustomInput";
import CountrySearch from "@/components/CountrySearch";
import Checkbox from "@/components/Checkbox";
import PaymentStep from "@/components/PaymentStep";
export default {
name: 'SubscriptionForm',
  data() {
    return {
        showBillingAddress: false,
        billingInfo:{
            name: this.organization.name,
            vatNumber: this.organization.companyId,
            legalAddress: {
                address: this.organization.address,
                postalCode: this.organization.zipCode,
                city: this.organization.city,
                country: this.organization.country
            },
            billingSameAsLegal: true,
            billingAddress: {
                address: "",
                postalCode: "",
                city: "",
                country: ""
            },
            contact: {
                name: this.organization.contact,
                email: this.organization.email
            },
            cardId: "",
            planTermsUuid: "",
            payWithInvoice: false
        },

        tersmChecked: false,
        paymentFrequency: this.initialPaymentFrequency,
        termsNConditions: this.$t('subscription.accept-terms'),
        invalidInputs:[],
        validInputs:[],
        countrySearch: '',
        // paymentInfo: false
    }
  },
    props:{
        plan: Object,
        plans: Array,
        currentCurrency: String,
        organization: Object,
        paymentInfoStep: Boolean,
        initialPaymentFrequency: String
    },
    methods:{
        gatherInfo(){
            let validation = this.validateFormInputs() 
            if(validation == true){
                this.$set( this.billingInfo, 'planterms_set', this.paymentFrequency == "month" ? this.monthlyPrice : this.annualPrice )
                // this.$set( this.billingInfo, 'uuid', this.paymentFrequency == "month" ? this.monthlyPrice.uuid : this.annualPrice.uuid )

                // this.billingInfo.planterms_set = this.paymentFrequency == "month" ? this.monthlyPrice : this.annualPrice
                this.$store.state.billingInfoTemporary = this.billingInfo
                console.log(this.billingInfo)
                this.$emit('paymentStep')
            } else console.log("didnt pass validation")
        },
        validateFormInputs(){
            this.invalidInputs = []
            this.validInputs = []
            let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
            // !this.billingInfo.vatNumber || this.billingInfo.vatNumber.length < 8 ? this.invalidInputs.push('CVR') : this.validInputs.push('CVR')
            !this.billingInfo.legalAddress.address || this.billingInfo.legalAddress.address.length < 2 ? this.invalidInputs.push('address') : this.validInputs.push('address')
            !this.billingInfo.legalAddress.postalCode || this.billingInfo.legalAddress.postalCode.length < 4 ? this.invalidInputs.push('zipCode') : this.validInputs.push('zipCode')
            !this.billingInfo.legalAddress.city || this.billingInfo.legalAddress.city.length < 2 ? this.invalidInputs.push('city') : this.validInputs.push('city')
            !this.billingInfo.legalAddress.country || this.billingInfo.legalAddress.country.length != 2 || !this.$store.state.validCountryCodes.includes(this.billingInfo.legalAddress.country) ? this.invalidInputs.push('country') : this.validInputs.push('country')
            
            !this.billingInfo.contact.email || !emailRegex.test(this.billingInfo.contact.email.toLowerCase()) ? this.invalidInputs.push('email') : this.validInputs.push('email')
            !this.billingInfo.contact.name || this.billingInfo.contact.name  < 2 ? this.invalidInputs.push('contact-name') : this.validInputs.push('contact-name')
            
            if(this.showBillingAddress == true){
                !this.billingInfo.billingAddress.address || this.billingInfo.billingAddress.address.length < 2 ? this.invalidInputs.push('billing-address') : this.validInputs.push('billing-address')
                !this.billingInfo.billingAddress.postalCode || this.billingInfo.billingAddress.postalCode.length < 4 ? this.invalidInputs.push('billing-zipCode') : this.validInputs.push('billing-zipCode')
                !this.billingInfo.billingAddress.city || this.billingInfo.billingAddress.city.length < 2 ? this.invalidInputs.push('billing-city') : this.validInputs.push('billing-city')
                !this.billingInfo.billingAddress.country || this.billingInfo.billingAddress.country.length != 2 ? this.invalidInputs.push('billing-country') : this.validInputs.push('billing-country')
            }
            return this.invalidInputs.length != 0 ? false : true
            // return true
        }
    },
    computed:{
        monthlyPrice(){
          let priceData = this.plan.planterms_set.find(plan => plan.currency == this.currentCurrency && plan.interval_type || plan.intervalType == "month" ) 
        //   let priceData = this.plan.planterms_set.find(plan => plan.currency == this.currentCurrency  ) 
        //   priceData.monthlyPriceForAnnual = parseInt(priceData.price) / 12
          return priceData
        },
        annualPrice(){
            let priceData = this.plan.planterms_set.find(plan => plan.currency == this.currentCurrency && plan.interval_type || plan.intervalType == "year" ) 
            // let priceData = this.plan.planterms_set.find(plan => plan.currency == this.currentCurrency  ) 
            return priceData
        },
        annualPriceIfMonthly(){
            let price = parseInt(this.monthlyPrice.price) * 12
            return price.toLocaleString().replace(/\./g, ' ')
        },
        annualPriceIfAnnual(){
            let price = parseInt(this.monthlyPrice.price).toFixed(0)*12 - parseInt(this.annualPrice.price).toFixed(0)
            return price.toLocaleString().replace(/\./g, ' ') 
        },
        valid(){  
            return this.tersmChecked
        }
    },
    watch: {
        showBillingAddress: {
            handler: function (val, oldVal) {
                if(this.showBillingAddress == true){
                    this.billingInfo.billingSameAsLegal = false
                } else  this.billingInfo.billingSameAsLegal = true
            }
        }
    },
    components:{
        CustomInput,
        SubscriptionPlan,
        Checkbox,
        CountrySearch,
        PaymentStep
    }
}
</script>

<style lang="less">
.form-container{
    // transition: .1s;
    max-width: 100%;
    h4{
        font-size: 16px;
        font-weight: normal;
    }
}
.shrink-container{
    max-width: 500px;
    margin: 0 auto;
}
#subscription-form{
    // margin-top: 24px;
    padding: 20px 0px 20px 0;
    display: grid;
    gap: 20px;
    grid-template-columns: minmax(300px, 500px) minmax(240px, 280px);
    
    // grid-template-columns: minmax(200px, 240px) minmax(250px, auto) minmax(200px, auto);
    // display: flex;
    // gap: 20px;
    justify-content: center;

    .checkout-steps{
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 20px;

        .step{
            border-radius: var(--standard-border-radius);
            padding: 20px;
            background-color: var(--background-white);
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        }
    }
    .order-review{
        & > div{
            position: sticky;
            top: 20px;
            .chosen-plan{
                padding: 20px;  
                border-radius: var(--standard-border-radius);
                background-color: var(--background-white);
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            }
        }   
    } 
    .city-info{
        display: grid;
        gap: 12px;
        grid-template-columns: 100px auto;
    }  
    .payment-info{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .payment-frequency > div{
        cursor: pointer;
        padding: 20px;
        border-radius: var(--standard-border-radius);
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.205);
        margin-bottom: 20px;
        background: #fafafa;
        transition: .1s;
        p.payment-header, p.payment-pricing{
            font-weight: bold;
            margin-bottom: 2px;
        }
        .binding, .total-year{
            font-weight: bold;
            font-size: 12px;
            color: #8f979c;
            margin-bottom: 2px;
        }
        .saving-year{
            font-weight: bold;
            font-size: 12px;
            margin-bottom: 2px;
        }
        p span:first-of-type{
            margin-right: 4px;
        }
        &.active{
            border: 1px solid var(--flame);
            box-shadow: 0px 6px 16px -5px #00000065;
            padding: 19px;
            background-color: var(--flame);
            color: #fff;
            span, p{
                color: #fff;
            }
        }
    }

    .custom-billing{
        margin: 12px 0 0 0;
    }

    .actions{
        margin-top: 12px;
        display: flex;
        flex-direction: column;
    }

}
</style>
